
import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { PermissionService } from '@core/services/permission.service';


export const permissionGuard: CanActivateFn = (route, state) => {
  const permissionService = inject(PermissionService);
  const router = inject(Router);

  const required = route.data?.['requiredPermissions'] as string[] | undefined;
  const requireAll = route.data?.['requireAll'] as boolean | undefined;
  
  const editPermissions = route.data?.['editPermissions'] as string[] | undefined;
  const isEditRoute = route.url.length > 0 && route.url[0].path === 'edit';
  
  const permissionsToCheck = isEditRoute && editPermissions ? editPermissions : required;

  if (!permissionsToCheck || permissionsToCheck.length === 0) {
    return true; 
  }

  const hasPermission = requireAll
    ? permissionsToCheck.every(p => permissionService.hasPermission(p))
    : permissionsToCheck.some(p => permissionService.hasPermission(p));
  
  if (!hasPermission) {
    console.warn('Access denied. Required permissions:', permissionsToCheck);
    console.warn('User permissions:', permissionService.getPermissions());
    
    return router.createUrlTree(['/access-denied'], {
      queryParams: { returnUrl: state.url }
    });
  }
  
  return true;
};


export function checkRoutePermissions(route: ActivatedRouteSnapshot, permissionService: PermissionService): boolean {
  const required = route.data?.['requiredPermissions'] as string[] | undefined;
  const requireAll = route.data?.['requireAll'] as boolean | undefined;

  if (!required || required.length === 0) {
    return true;
  }

  return requireAll
    ? required.every(p => permissionService.hasPermission(p))
    : required.some(p => permissionService.hasPermission(p));
}